import { Configuration, OrganizationsApi } from '@/api';
import { fetchAllPaginated } from '@/api/utils';
import SelectBox, { SelectBoxProps } from '@/components/select/SelectBox';
import { Organization } from '@/models/Organization';
import { useAuth } from '@/modules/auth/contexts/AuthContext';

export interface OrganizationItem {
  id: string;
  name: string;
  organization: Organization;
}

const OrganizationSelectBox = (props: SelectBoxProps<OrganizationItem>) => {
  const organizationsApi = new OrganizationsApi(new Configuration(useAuth));

  const listOrganizations = async (): Promise<OrganizationItem[]> => {
    const organizations = await fetchAllPaginated<Organization>(
      (offset, limit) => organizationsApi.listOrganizations(offset, limit),
      100,
      1000,
    );

    return organizations.map((organization) => {
      return {
        id: organization.id,
        name: organization.name,
        organization,
      };
    });
  };

  const { label = 'Organization:', placeholder = 'Select organization' } = props;

  return (
    <SelectBox<OrganizationItem>
      {...props}
      name="organization"
      label={label}
      placeholder={placeholder}
      queryFn={listOrganizations}
      queryKey={['organization']}
    />
  );
};

export default OrganizationSelectBox;
